import {Component, inject} from '@angular/core';
import {RestClient} from '../../../../Api/DcoApi/Client/RestClient';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {Absetzung} from '../../../../Main/Pages/Abrechnung/Absetzung';
import {AbsetzungsDateien} from '../../../../Main/Pages/Abrechnung/Popups/absetzungs-dateien/absetzungs-dateien';
import {DatePipe, NgForOf} from '@angular/common';
import {PhoneCall} from '../../../../Componente/PhoneCall';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EditSubscriptionPartner} from '../edit-subscription-partner/edit-subscription-partner';

@Component({
  selector: 'add-subscription',
  imports: [
    Absetzung,
    AbsetzungsDateien,
    DatePipe,
    NgForOf,
    PhoneCall,
    ReactiveFormsModule,
    FormsModule,
    EditSubscriptionPartner
  ],
  templateUrl: './add-subscription.html',
  styleUrl: './add-subscription.css',
})
export class AddSubscription {
  Client: RestClient = new RestClient();
  modal = inject(NgbActiveModal);
  request: RequestModel = { type: 0, url: "", name: "", partnerIds: [] };

  Endpoints = [
    { key: 0, Bezeichnung: "AuftragChanged" },
    { key: 1, Bezeichnung: "AuftragStatusChanged" },

  ]

  async SendNew()
  {
    var res = await this.Client.Post<any, RequestModel>(`/Backend/Api/V2/Admin/PushSubscription`, this.request);
    this.modal.close();
  }

}


interface RequestModel {
  type: number;
  url: string;
  name: string;
  partnerIds: number[];
}
